module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/user-session-store-actions/~/babel-runtime/core-js/object/assign.js
// module id = 234
// module chunks = 0 1